import { Record } from "immutable";

class FinancialYearRecord extends Record({
    id: null,
    name: null,
    create_date: null,
    modified_date: null,
    is_active: null,
    created_by: null,
    modified_by: null,
    start_date: null,
    end_date: null
}) {}

class FinancialDetailRecord extends Record({
    id: null,
    case: null,
    company: null,
    financial_year: {
        id: null,
        create_date: null,
        modified_date: null,
        is_active: null,
        name: null,
        created_by: null,
        start_date: null,
        end_date: null,
        modified_by: null
    },
    created_by: null,
    modified_by: null,
    create_date: null,
    modified_date: null,
    is_active: true,
    pnl_revenue_sales: 0,
    pnl_revenue_other_income: 0,
    pnl_purchase_raw_material: 0,
    pnl_purchase_spare: 0,
    pnl_cost_of_goods_opening_stock: 0,
    pnl_cost_of_goods_closing_stock: 0,
    pnl_cost_of_direct_expense: 0,
    pnl_gross_profit: 0,
    pnl_expense_salary_to_staff: 0,
    pnl_expense_depreciation: 0,
    pnl_expense_other_expenses: 0,
    pnl_finance_cost_interest_paid: 0,
    pnl_ebidta: 0,
    pnl_pbit: 0,
    pnl_pbt: 0,
    pnl_taxes: 0,
    pnl_pat: 0,
    //Liabilities
    bs_liabilities_lt1yr_cc_od: 0,
    bs_liabilities_lt1yr_creditors: 0,
    bs_liabilities_lt1yr_advances: 0,
    bs_liabilities_lt1yr_provision: 0,
    bs_liabilities_lt1yr_tl_emi_payable: 0,
    bs_liabilities_lt1yr_other_liabilities: 0,
    bs_liabilities_gte1yr_term_loan: 0,
    bs_liabilities_gte1yr_unsecured_loan: 0,
    bs_liabilities_gte1yr_other_liabilities: 0,
    bs_liabilities_networth_equity: 0,
    bs_liabilities_networth_quasi_equity: 0,
    //assets
    bs_assets_ca_cash_bank_balance: 0,
    bs_assets_ca_investment: 0,
    bs_assets_ca_debtors: 0,
    bs_assets_ca_closing_stock: 0,
    bs_assets_ca_advance_tax: 0,
    bs_assets_ca_loan_and_advances: 0,
    bs_assets_ca_other_current_asset: 0,
    bs_assets_fa_gross_block: 0,
    bs_assets_fa_depreciation: 0,
    bs_assets_nca_loans_and_advances: 0,
    bs_assets_nca_debtor: 0,
    bs_assets_nca_deferred_taxes: 0,
    bs_assets_nca_investment: 0,
    bs_assets_nca_other_nca: 0,
    bs_difference: 0,
    ratio_debt_equity: 0,
    ratio_tol_by_tnw: 0,
    ratio_current_ratio: 0,
    ratio_net_working_capital: 0,
    ratio_dscr_numerator: 0,
    ratio_dscr_denominator: 0,
    ratio_dscr: 0,
    ratio_interest_coverage_ratio: 0,
    ratio_ebitda: 0,
    ratio_ebitda_by_net_sales: 0,
    ratio_creditor_turnover_days: 0,
    ratio_debtor_turnover_days: 0
}) {
    get pnl_net_sales() {
        return this.pnl_revenue_sales + this.pnl_revenue_other_income;
    }
    get pnl_total_purchase() {
        return this.pnl_purchase_raw_material + this.pnl_purchase_spare;
    }
    get pnl_total_expense() {
        return (
            this.pnl_expense_salary_to_staff +
            this.pnl_expense_depreciation +
            this.pnl_expense_other_expenses
        );
    }
    get pnl_cogs() {
        return (
            this.pnl_total_purchase +
            this.pnl_cost_of_goods_opening_stock -
            this.pnl_cost_of_goods_closing_stock +
            this.pnl_cost_of_direct_expense
        );
    }

    get pnl_gross_profit() {
        return this.pnl_net_sales - this.pnl_cogs;
    }

    get pnl_ebidta() {
        return this.pnl_gross_profit - this.pnl_expense_salary_to_staff - this.pnl_expense_other_expenses;
    }

    get pnl_pbit() {
        return this.pnl_net_sales - this.pnl_cogs - this.pnl_total_expense;
    }
    get pnl_pbt() {
        return this.pnl_pbit - this.pnl_finance_cost_interest_paid;
    }
    get pnl_pat() {
        return this.pnl_pbt - this.pnl_taxes;
    }
    get bs_liabilities_tnw() {
        return (
            this.bs_liabilities_networth_equity +
            this.bs_liabilities_networth_quasi_equity
        );
    }

    get bs_total_borrowings_lt1yr() {
        return (
            this.bs_liabilities_lt1yr_cc_od +
            this.bs_liabilities_lt1yr_creditors +
            this.bs_liabilities_lt1yr_advances +
            this.bs_liabilities_lt1yr_provision +
            this.bs_liabilities_lt1yr_tl_emi_payable +
            this.bs_liabilities_lt1yr_other_liabilities
        );
    }

    get bs_total_borrowings_gte1yr() {
        return (
            this.bs_liabilities_gte1yr_term_loan +
            this.bs_liabilities_gte1yr_unsecured_loan +
            this.bs_liabilities_gte1yr_other_liabilities
        );
    }
    get bs_total_current_asset() {
        return (
            this.bs_assets_ca_cash_bank_balance +
            this.bs_assets_ca_investment +
            this.bs_assets_ca_debtors +
            this.bs_assets_ca_closing_stock +
            this.bs_assets_ca_advance_tax +
            this.bs_assets_ca_loan_and_advances +
            this.bs_assets_ca_other_current_asset
        );
    }
    get bs_total_fixed_asset() {
        return this.bs_assets_fa_gross_block - this.bs_assets_fa_depreciation;
    }
    get bs_total_debit() {
        return (
            this.bs_liabilities_lt1yr_cc_od +
            this.bs_liabilities_gte1yr_term_loan +
            this.bs_liabilities_gte1yr_unsecured_loan
        );
    }
    get bs_total_liabilities() {
        return (
            this.bs_liabilities_tnw +
            this.bs_total_borrowings_lt1yr +
            this.bs_total_borrowings_gte1yr
        );
    }

    get bs_tol() {
        return this.bs_total_borrowings_lt1yr + this.bs_total_borrowings_gte1yr;
    }
    get bs_total_non_current_asset() {
        return (
            this.bs_assets_nca_loans_and_advances +
            this.bs_assets_nca_debtor +
            this.bs_assets_nca_deferred_taxes +
            this.bs_assets_nca_investment +
            this.bs_assets_nca_other_nca
        );
    }
    get bs_total_asset() {
        return (
            this.bs_total_current_asset +
            this.bs_total_non_current_asset +
            this.bs_total_fixed_asset
        );
    }

    get bs_difference() {
        return Math.ceil(this.bs_total_asset - this.bs_total_liabilities);
    }

    get ratio_debt_equity() {
        return this.bs_liabilities_tnw
            ? this.bs_total_debit / this.bs_liabilities_tnw
            : 0;
    }
    get ratio_tol_by_tnw() {
        return this.bs_liabilities_tnw
            ? this.bs_tol / this.bs_liabilities_tnw
            : 0;
    }
    get ratio_current_ratio() {
        return this.bs_total_borrowings_lt1yr
            ? this.bs_total_current_asset / this.bs_total_borrowings_lt1yr
            : 0;
    }
    get ratio_net_working_capital() {
        return this.bs_total_current_asset - this.bs_total_borrowings_lt1yr;
    }
    get ratio_ebitda() {
        return this.pnl_ebidta;
        // return (
        //     this.pnl_net_sales -
        //     this.pnl_total_purchase -
        //     this.pnl_expense_salary_to_staff -
        //     this.pnl_expense_other_expenses
        // );
    }
    get ratio_ebitda_by_net_sales() {
        return this.pnl_net_sales
            ? (this.pnl_ebidta / this.pnl_net_sales) * 100
            : 0;
    }
    get ratio_creditor_turnover_days() {
        return this.pnl_total_purchase
            ? (this.bs_liabilities_lt1yr_creditors / this.pnl_total_purchase) *
                  365
            : 0;
    }
    get ratio_debtor_turnover_days() {
        return this.pnl_net_sales
            ? (this.bs_assets_ca_debtors / this.pnl_net_sales) * 365
            : 0;
    }

    get ratio_dscr_numerator() {
        return (
            this.pnl_pat +
            this.pnl_expense_depreciation +
            this.pnl_finance_cost_interest_paid
        );
    }
    get ratio_dscr_denominator() {
        return (
            this.bs_liabilities_lt1yr_tl_emi_payable +
            this.pnl_finance_cost_interest_paid
        );
    }

    get ratio_dscr() {
        return this.ratio_dscr_denominator > 0
            ? this.ratio_dscr_numerator / this.ratio_dscr_denominator
            : 0;
    }

    get ratio_interest_coverage_ratio() {
        return this.pnl_finance_cost_interest_paid > 0
            ? this.pnl_pbit / this.pnl_finance_cost_interest_paid
            : 0;
    }

    static average_dscr(f1, f2) {
        return f1.ratio_dscr_denominator || f1.ratio_dscr_denominator
            ? (f1.ratio_dscr_numerator + f2.ratio_dscr_numerator) /
                  (f1.ratio_dscr_denominator + f2.ratio_dscr_denominator)
            : 0;
    }
}

export { FinancialYearRecord, FinancialDetailRecord };
